var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.isLoading)?_c('v-main',{staticClass:"login-bg"},[_c('router-view')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }